import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-table-list-header',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="header-container">
      <div class="header-content">
        <h1 class="header-title">{{ title }}</h1>
        <div class="header-actions">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
  styleUrl: './table-list-header.component.scss'
})
export class TableListHeaderComponent {
  @Input() title: string = '';
}